import React, { useState, useEffect } from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Nav from 'react-bootstrap/Nav';
import { Navbar, NavDropdown, Card, Form, Button, Modal } from 'react-bootstrap';
import Table from 'react-bootstrap/Table';
import Pagination from 'react-js-pagination';
import Loader from "../Loader";
import { Link, useHistory } from "react-router-dom";
import axios from "axios";
import pro from "../../../images/splash/prof.png";
import { var_api } from "../../constant";
import sage from "../../../images/splash/sage.jpeg";

const Reportss = () => {
  const history = useHistory();
  const [showBanner, setShowBanner] = useState(true);
  const [selectedTab, setSelectedTab] = useState('All reports');
  const [searchQuery, setSearchQuery] = useState('');
  const [filteredReports, setFilteredReports] = useState([]);
  const [loading, setLoading] = useState(false);
  const [reports] = useState([
    { tab: "Sales", name: "Sales Summary", description: "Sales quantities and value, excluding gift card sales.", route: '/sales_summary', icon: 'bi bi-tag' },
  { tab: "Sales", name: "Membership List", description: "Complete list of active memberships.", route: '/memberlist', icon: 'bi bi-tag' },
  { tab: "Sales", name: "Coupon List", description: "Complete list of active coupons.", route: '/couponlist', icon: 'bi bi-tag' },
  { tab: "Appointments", name: "Appointments Summary", description: "General overview of appointment trends and patterns, including cancellations and no-shows.", route: '/appointment_summary', icon: 'bi bi-calendar2-fill' },
  { tab: "Appointments", name: "Appointments List", description: "Full list of scheduled appointments.", route: '/appointment_list', icon: 'bi bi-calendar2-fill' },
  { tab: "Appointments", name: "Appointments Cancellation", description: "Insight into appointment cancellations and no-shows.", route: '/cancellation_list', icon: 'bi bi-calendar2-fill' },
  { tab: "Appointments", name: "Waitlist Summary", description: "Overview of waitlist trends, including appointments booked and expired waitlist entries.", route: '/waitlist_summary', icon: 'bi bi-calendar2-fill' },
  { tab: "Appointments", name: "Membership Appointments", description: "Detailed view of Membership entries.", route: '/membership_appointments', icon: 'bi bi-calendar2-fill' },
  { tab: "Appointments", name: "Coupon Appointments", description: "Detailed view of Coupon entries.", route: '/coupon_appointments', icon: 'bi bi-calendar2-fill' },
  { tab: "Team", name: "Working Hour Summary", description: "Detailed view of team members' worked hours and appointments.", route: '/team', icon: 'bi bi-people' },
  { tab: "Clients", name: "Clients Summary", description: "Overview of new, returning, and walk-in clients.", route: '/client_summary', icon: 'bi bi-emoji-smile' },
  { tab: "Clients", name: "Client List", description: "Comprehensive list of all active clients.", route: '/client', icon: 'bi bi-emoji-smile' },
  { tab: "Clients", name: "Client Insight", description: "Deep dive into individual client behavior and preferences.", route: '/client_insight', icon: 'bi bi-emoji-smile' }
  ]);

  useEffect(() => {
    // const tokens = localStorage.getItem("token");
    
  }, [history]);

  useEffect(() => {
    // Filter reports based on search query
    setFilteredReports(reports.filter(report =>
      report.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      (report.description && report.description.toLowerCase().includes(searchQuery.toLowerCase()))
    ));
  }, [searchQuery, reports]);

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const handleRoute = (route) => {
    history.push(route);
  };
  const handleGoToHome = () => {
    history.push('/sb-home');
  }

  return (
    <Container>
      {loading && <Loader />}  
      <Navbar bg="light" expand="md" className="bg-body-tertiary" collapseOnSelect fixed="top">
  <Navbar.Brand href="#home">
    <img src={sage} alt="logo" className="img-fluid" style={{ maxWidth: "200px", margin: "3px 80px" }} />
  </Navbar.Brand>
  <Navbar.Toggle aria-controls="responsive-navbar-nav" />
  <Navbar.Collapse id="responsive-navbar-nav">
  <Nav className="mx-auto">
      <Nav.Link href="#" style={{ color: "black", fontSize:"25px", letterSpacing:"2px" }}>
      Reporting and analytics
      </Nav.Link>
    </Nav>
    <Nav className="ms-auto">
      <Nav.Link onClick={handleGoToHome}  style={{ color: "black", fontSize: "15px" }}>
        <button className="btn" style={{backgroundColor:"rgb(89, 128, 71)", color:"white"}}>
          <i className="bi bi-house"></i> Go to home
        </button>
      </Nav.Link>
    </Nav>
  </Navbar.Collapse>
</Navbar>
<br/>
<br/>
<br/>
<br/>

      {showBanner && (
        <Card style={{ backgroundColor: "#65b2ed6c",border: "none", padding: "15px 27px", margin: "auto", height: "auto", borderRadius: "20px", boxShadow: "rgba(0, 0, 0, 0.16) 0px 3px 6px, rgb(89, 128, 71, 0.50) 0px 3px 6px" }}>
          <Card.Body>
            <Row>
              <Col>
                <Card.Title style={{ fontSize: '1.5rem', color: 'black' }}>Better, faster, smarter reports</Card.Title>
              </Col>
              <Col xs="auto" style={{ display: 'flex', alignItems: 'center' }}>
                <Button 
                  variant="link" 
                  onClick={() => setShowBanner(false)} 
                  style={{ fontSize: '1.25rem', color: '#000', textDecoration: 'none' }}
                >
                  ✕
                </Button>
              </Col>
            </Row>
            <Row>
              <Col>
                <Card.Text style={{ fontSize: '1.1rem' }}>
                  Your reports are now smarter and more convenient than ever, putting the data you need to grow your business right at your fingertips.
                </Card.Text>
                <Button variant="light">Learn more</Button>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      )}
      <Row className="mt-4" style={{ maxWidth: '300px' }}>
        <Col>
          <Form.Control
            type="text"
            placeholder="Search"
            value={searchQuery}
            onChange={handleSearchChange}
          />
        </Col>
      </Row>

      <Row className="mt-4">
        <Col>
          <Nav variant="tabs" activeKey={selectedTab} onSelect={(selectedKey) => setSelectedTab(selectedKey)}>
            <Nav.Item>
              <Nav.Link eventKey="All reports">All reports</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="Sales">Sales</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="Appointments">Appointments</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="Team">Team</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="Clients">Clients</Nav.Link>
            </Nav.Item>
          </Nav>
        </Col>
      </Row>
      
      <Row className="mt-4">
        <Col>
          <div className="report-list">
            {filteredReports.map((report) => (
              (selectedTab === 'All reports' || selectedTab === report.tab) && (
                <Card key={report.name} style={{marginBottom: "15px", border: "none", padding: "5px", height: "auto", borderRadius: "20px", boxShadow: "rgba(0, 0, 0, 0.16) 0px 3px 6px, rgb(89, 128, 71, 0.50) 0px 3px 6px" }}
                 onClick={() => handleRoute(report.route)}>
                  <Card.Body>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <i className={report.icon} style={{ fontSize: '1.5rem', marginRight: '10px', color: '#598047' }}></i>
                    <Card.Title style={{ margin: 0 }}>{report.name}</Card.Title>
                  </div>
                  <Card.Text>{report.description}</Card.Text>
                  </Card.Body>
                </Card>
              )
            ))}
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default Reportss;
